export default {
  'camp67-navigation.the-camp': 'キャンプ',
  'camp67-navigation.camp67': 'camp67',
  'camp67-navigation.camp67.who-are-we': '私たちについて',
  'camp67-navigation.camp67.camp67-&-kumbh': 'camp67 & クンブ',
  'camp67-navigation.camp67.camp67-&-the-land': 'camp67 & 土地',
  'camp67-navigation.kumbh-2025': 'マグ メラ 2026',
  'camp67-navigation.kumbh-2025.significance-of-kumbh': 'クンブの重要性',
  'camp67-navigation.kumbh-2025.paush-purnima': 'パウシャ・プルニマ（1月3日）',
  'camp67-navigation.kumbh-2025.makar-sankranti': 'マカル サンクランティ (1月14日)',
  'camp67-navigation.kumbh-2025.mauni-amavasya': 'マウニ・アマヴァスヤ（1月18日）',
  'camp67-navigation.kumbh-2025.basant-panchami': 'ヴァサント・パンチャミ（1月23日）',
  'camp67-navigation.kumbh-2025.maghi-purnima': 'マーギー・プルニマ（2月1日）',
  'camp67-navigation.kumbh-2025.maha-shivratri': 'マハー・シヴァラートリ（2月15日）',
  'camp67-navigation.packages': 'パッケージ',
  'camp67-navigation.packages.reserve-a-room': '部屋を予約する',
  'camp67-navigation.packages.twin-room': 'ツインベッドコテージ',
  'camp67-navigation.packages.family-room': 'ファミリーコテージ',
  'camp67-navigation.packages.family-room-plus': 'ファミリーコテージプラス',
  'camp67-navigation.packages.dormitory-single': 'ドミトリー（シングル）',
  'camp67-navigation.packages.dormitory-bunk': 'ドミトリー（バンク）',
  'camp67-navigation.contact-us': 'お問い合わせ',
  'camp67-banner.inquire-now': '興味を表明',
  'camp67-banner.book-now': '今すぐ予約',
  'camp67-header.tagline': '平和の神聖な集い。',
  'camp67-header.typewriter.prefix': '最も ',
  'camp67-header.typewriter.serene': '静かな',
  'camp67-header.typewriter.peaceful': '平和な',
  'camp67-header.typewriter.safe': '安全な',
  'camp67-header.typewriter.secure': '安心な',
  'camp67-header.typewriter.hygienic': '衛生的な',
  'camp67-header.typewriter.affordable': '手頃な価格の',
  'camp67-header.typewriter.suffix.start': 'キャンプ場で',
  'camp67-header.typewriter.suffix.end': 'マグ メラ 2026.',
  'camp67-header.reserve-your-spot.prefix.desktop': '今すぐ予約',
  'camp67-header.reserve-your-spot.prefix.mobile': '今すぐ予約',
  'camp67-header.reserve-your-spot.secure-checkout': '安心のチェックアウト：',
  'camp67-link.sukrit-wellness-tours': 'Sukrit Wellness Tours →',
  'camp67-link.kumbh-sukrit-camp': 'Kumbh Sukrit Camp →',
  'camp67-link.see-more-on': 'もっと見る',
  'camp67-link.learn-more': 'もっと学ぶ',
  'camp67-link.terms-of-service': '利用規約',
  'camp67-link.privacy-policy': 'プライバシーポリシー',
  'camp67-link.payment-policy': '支払い方針',
  'camp67-link.cancellation-policy': 'キャンセルポリシー',
  'camp67.submit': '送信',
  'camp67.reset': 'リセット',
  'camp67.continue': '支払い →',
  'camp67.go-back': '戻る',
  'camp67.ssl': 'SSLおよびブラウザのセキュリティポリシーにより保護されています。',
  'camp67-one-of-a-kind.premium.prefix':
    'からのプレミアムドミトリー＆プライベートコテージプロバイダー',
  'camp67-one-of-a-kind.team-behind': 'のチームから',
  'camp67-one-of-a-kind.quality.hygienic.title': '衛生的',
  'camp67-one-of-a-kind.quality.hygienic.image-alt':
    '国際的に有名なサンスクリット歌手、フランスからの特別ゲストGabriella BurnelがGaushalaの敷地に座っています。',
  'camp67-one-of-a-kind.quality.hygienic.text': '国際水準であなたの快適さを保証します。',
  'camp67-one-of-a-kind.quality.safe-and-secure.title': '安全かつ安心',
  'camp67-one-of-a-kind.quality.safe-and-secure.image-alt':
    'Kumbh Sukritキャンプ2019の高くて安全なゲート。',
  'camp67-one-of-a-kind.quality.safe-and-secure.text': '著名人や公人が選ぶ宿泊先。',
  'camp67-one-of-a-kind.quality.peaceful.title': '平和',
  'camp67-one-of-a-kind.quality.peaceful.image-alt':
    '背の高い木々、清潔な歩道、美しい環境に囲まれたKumbh Sukritキャンプの平和な森のような囲い。',
  'camp67-one-of-a-kind.quality.peaceful.text':
    'リシが時を越えて瞑想してきた <i>Sanskriti Vann</i> に位置しています。',
  'camp67-one-of-a-kind.graphic.2013': '500+ 参加者、10+ か国',
  'camp67-one-of-a-kind.graphic.2019': '10,000 人の参加者、26 か国',
  'camp67-one-of-a-kind.graphic.2025.description': 'これまでに予約された',
  'camp67-one-of-a-kind.graphic.2025.book-now': '今すぐ予約!',
  'camp67-one-of-a-kind.calendar.paush-purnima.date': '2026年1月3日',
  'camp67-one-of-a-kind.calendar.paush-purnima.title': 'Pausha Purnima',
  'camp67-one-of-a-kind.calendar.paush-purnima.description':
    'Magh Mela の開幕を告げる、最初の主要な沐浴日。',
  'camp67-one-of-a-kind.calendar.makar-sankranti.date': '2026年1月14日',
  'camp67-one-of-a-kind.calendar.makar-sankranti.title': 'Makar Sankranti',
  'camp67-one-of-a-kind.calendar.makar-sankranti.description':
    '最も吉兆とされる日の一つ。太陽が山羊座に入ります。',
  'camp67-one-of-a-kind.calendar.mauni-amavasya.date': '2026年1月18日',
  'camp67-one-of-a-kind.calendar.mauni-amavasya.title': 'Mauni Amavasya',
  'camp67-one-of-a-kind.calendar.mauni-amavasya.description':
    '「沐浴（スナーン）の王」。信者は沈黙を守り、聖なる沐浴を行います。',
  'camp67-one-of-a-kind.calendar.basant-panchami.date': '2026年1月23日',
  'camp67-one-of-a-kind.calendar.basant-panchami.title': 'ヴァサント・パンチャミー',
  'camp67-one-of-a-kind.calendar.basant-panchami.description':
    '春の訪れ。女神サラスヴァティーに捧げられる日です。',
  'camp67-one-of-a-kind.calendar.maghi-purnima.date': '2026年2月1日',
  'camp67-one-of-a-kind.calendar.maghi-purnima.title': 'Maghi Purnima',
  'camp67-one-of-a-kind.calendar.maghi-purnima.description':
    '苦行を終えるカルプワーシーにとって重要な沐浴（スナーン）の日です。',
  'camp67-one-of-a-kind.calendar.maha-shivratri.date': '2026年2月15日',
  'camp67-one-of-a-kind.calendar.maha-shivratri.title': 'Maha Shivratri',
  'camp67-one-of-a-kind.calendar.maha-shivratri.description':
    'マグ・メーラの最終日。シヴァ神に捧げられる日です。',
  'camp67-we-love-kumbh.decade-old': '十年の物語',
  'camp67-we-love-kumbh.we-know-and': '私たちは知っています',
  'camp67-we-love-kumbh.love': '愛する',
  'camp67-we-love-kumbh.rto-kumbh-hosts':
    '登録ツアーオペレーターとして、Incredible Indiaと共に10年以上にわたりクンブを開催しています。',
  'camp67-we-love-kumbh.moments-kumbh-2019': '2019年のクンブの瞬間',
  'camp67-we-love-kumbh.hear-from-visitors': '国際的な訪問者の声を聞く',
  'camp67-we-love-kumbh.richard-testimonial.location': 'ニューヨーク、アメリカ',
  'camp67-we-love-kumbh.richard-testimonial.image-alt':
    '2019年、ニューヨークUSA出身のリチャード・シンが私たちのキャンプ場で。',
  'camp67-we-love-kumbh.richard-testimonial.quote':
    'キャンプは素晴らしい。スタッフは本当に素晴らしく親切でした。皆がここで私の友達になりました。',
  'camp67-we-love-kumbh.rajesh-testimonial.location': 'ボルボの購買部シニアVP',
  'camp67-we-love-kumbh.rajesh-testimonial.image-alt':
    '2019年、ボルボの購買部シニアVP、ラジェシュ・ミタルが私たちのキャンプ場で。',
  'camp67-we-love-kumbh.rajesh-testimonial.quote':
    'とても穏やかで神聖な体験でした。滞在を本当に楽しみました。そしてまたここに戻ってきたいです。',
  'camp67-we-love-kumbh.gabriella-testimonial.location':
    'サンスクリット学者、@gaieasanskrit',
  'camp67-we-love-kumbh.gabriella-testimonial.image-alt':
    '2019年、私たちのキャンプ場でサンスクリット学者ガブリエラ・バーネル。',
  'camp67-we-love-kumbh.gabriella-testimonial.quote':
    'この場所で学んだことの一つは、何も願う必要はないということです。自然の流れのままに起こります。',
  'camp67-we-love-kumbh.pawars-testimonial.location': 'マイクロソフト & Edukinect',
  'camp67-we-love-kumbh.pawars-testimonial.image-alt':
    '2019年、私たちのキャンプ場でマイクロソフトとEdukinectのアミットとスワプナ・パワール。',
  'camp67-we-love-kumbh.pawars-testimonial.quote':
    '非常に美しい、非常に快適です。全員のサービスがとても良かったです。',
  'camp67-our-location.ganges-banks': 'ガンジス川岸に',
  'camp67-our-location.lay-tents':
    '67のテントが<strong class="hidden sm:block">強く輝いて立っています</strong>',
  'camp67-our-location.ganges-banks-location':
    'ガンジス川の岸辺に位置しており、クンブのイベントを逃すことなく、おそらく静かでプライベートな囲い地を持つことができます。',
  'camp67-accommodation.twin-room.title': 'ツインベッドコテージ',
  'camp67-accommodation.twin-room.image-alt':
    '2つのシングルベッドと快適な座席アレンジメントがある部屋。',
  'camp67-accommodation.twin-room.subtitle': '二人用。',
  'camp67-accommodation.twin-room.description':
    'シングルベッド2台の居心地のよいコテージ。カップル、友人、きょうだいに最適です。',
  'camp67-accommodation.twin-room.guests': '2名',
  'camp67-accommodation.family-room.title': 'ファミリーコテージ',
  'camp67-accommodation.family-room.image-alt':
    'クイーンベッドが備わる広いダブルルームで、ベッドが1つ分、クイーンベッドに接続されています。',
  'camp67-accommodation.family-room.subtitle': '4人用のファミリー向け。',
  'camp67-accommodation.family-room.description':
    'クイーンベッドに二段ベッドが付属し、さらにシングルベッド1台を備えた広々としたコテージ。小さなご家族に理想的です。',
  'camp67-accommodation.family-room.guests': '4名',
  'camp67-accommodation.family-room-plus.title': 'ファミリーコテージプラス',
  'camp67-accommodation.family-room-plus.image-alt':
    'クイーンベッドが2つ、ベッドがそれぞれ接続された広いダブルルーム。',
  'camp67-accommodation.family-room-plus.subtitle': '6人用のファミリー向け。',
  'camp67-accommodation.family-room-plus.description':
    'クイーンベッドが2つ、それぞれベッドが接続されたスイート。大きな家族に最適です。',
  'camp67-accommodation.family-room-plus.guests': '6名',
  'camp67-accommodation.dorm-single.title': 'ドミトリー (シングル)',
  'camp67-accommodation.dorm-single.image-alt':
    '予算に優しい、リラックスできるシングルベッドのドミトリールーム。実際の施設には壁はありません。',
  'camp67-accommodation.dorm-single.subtitle': '一人用、ドミトリースタイル。',
  'camp67-accommodation.dorm-single.description':
    '大きなドミトリー内で8つの他のシングルベッドの中に1つのシングルベッドがある共通のスイート。',
  'camp67-accommodation.dorm-single.guests': '8名',
  'camp67-accommodation.dorm-bunk.title': 'ドミトリー (バンク)',
  'camp67-accommodation.dorm-bunk.image-alt':
    '予算に優しい、リラックスできるバンクベッドのドミトリールーム。実際の施設には壁はありません。',
  'camp67-accommodation.dorm-bunk.subtitle':
    'お一人様向け、ドミトリー（バンク）スタイル。',
  'camp67-accommodation.dorm-bunk.description':
    '大きなドミトリー内で8つの他のバンクベッドの中に1つのバンクベッドがある共通のスイート。',
  'camp67-accommodation.dorm-bunk.guests': '8名',
  'camp67-accommodation.price-per-guest': '/ 泊',
  'camp67-accommodation.price-meals-included': '食事込み',
  'camp67-accommodation.price-bathing-dates': 'バスタイム対象日',
  'camp67-accommodation.view-next': '次を表示 >',
  'camp67-accommodation.choose-accommodation': '宿泊施設を選ぶ',
  'camp67-accommodation.call-to-learn-more':
    '詳しく知るには、+91 84858 35675 に電話またはWhatsAppしてください。',
  'camp67-accommodation-and-amenities.amenities-included':
    'すべてのアメニティが含まれています',
  'camp67-accommodation-and-amenities.come-to-home':
    'あなたの<home-highlight>我が家</home-highlight>へ<br />もう一つの我が家として',
  'camp67-accommodation-and-amenities.choose-from-packages':
    '個人、カップル、家族、小グループ、大グループに適した宿泊パッケージからお選びください。',
  'camp67-accommodation-and-amenities.luxurious-title': '豪華なテント',
  'camp67-accommodation-and-amenities.luxurious-detail':
    '2、3、4、または6人用のデラックスコテージテント、またはシングルベッドおよび二段ベッド付きのテント寮。',
  'camp67-accommodation-and-amenities.all-in-one-city-title': '全てが揃ったテントシティ',
  'camp67-accommodation-and-amenities.all-in-one-city-detail':
    'プライベートコテージまたはドミトリーごとに共用エリア、訓練されたスタッフによる24/7サービス、および中央のカフェ。',
  'camp67-accommodation-and-amenities.heater-services-title': '暖房サービス',
  'camp67-accommodation-and-amenities.heater-services-detail':
    '加熱ソリューションを提供し、外気温に関係なく暖かく快適な環境を確保します。',
  'camp67-accommodation-and-amenities.cafe-central-title': '24時間営業のカフェセントラル',
  'camp67-accommodation-and-amenities.cafe-central-detail':
    'コーヒー、紅茶、および食品の選択を提供する24時間営業のカフェ。',
  'camp67-accommodation-and-amenities.daily-housekeeping-title': '毎日のハウスキーピング',
  'camp67-accommodation-and-amenities.daily-housekeeping-detail':
    '毎日清掃サービスを提供し、細部に特別な注意を払いながらスペースを掃除してくれます。',
  'camp67-accommodation-and-amenities.bottled-water-title': 'ボトル入り飲料水',
  'camp67-accommodation-and-amenities.bottled-water-detail':
    'お客様の水の健やかさと快適さを確保するため、毎日新しいプレミアム飲料水を無料で提供。',
  'camp67-accommodation-and-amenities.natural-gardens-title': 'スピリチュアル体験',
  'camp67-accommodation-and-amenities.natural-gardens-detail':
    'キャンプではヤグニャシャーラー、瞑想、ヨガなど、さまざまなスピリチュアル体験をご利用いただけます。',
  'camp67-accommodation-and-amenities.ayurvedic-products-title': 'アーユルヴェーダ製品',
  'camp67-accommodation-and-amenities.ayurvedic-products-detail':
    'ウェルネスと若返りのために、厳選された天然アーユルヴェーダのスキンケア製品をご利用いただけます。',
  'camp67-accommodation-and-amenities.minutes-from-ganges-title': 'ガンジス川から数分',
  'camp67-accommodation-and-amenities.minutes-from-ganges-detail':
    '神聖なガンジス川からわずか5分の散歩でアクセスしやすい場所にあります。',
  'camp67-accommodation-and-amenities.yoga-and-meditation-title': 'ヨガと瞑想セッション',
  'camp67-accommodation-and-amenities.yoga-and-meditation-detail':
    '古代インドの実践に参加してください。宿泊パッケージ価格に含まれています。',
  'camp67-tent-amenity.comfortable-living': '快適な生活',
  'camp67-tent-amenity.comfortable-living.single-beds':
    'シングルベッドセットまたは二段ベッドの選択',
  'camp67-tent-amenity.comfortable-living.single-bed': 'シングルベッド',
  'camp67-tent-amenity.comfortable-living.bunk-bed': '二段ベッド',
  'camp67-tent-amenity.comfortable-living.queen-bed':
    'クイーンと連結された二段ベッド、別のシングルベッド付き',
  'camp67-tent-amenity.comfortable-living.two-queen-beds':
    'クイーンベッド二つに連結された二段ベッド',
  'camp67-tent-amenity.comfortable-living.quilt-blanket-pillows': '毛布と枕',
  'camp67-tent-amenity.comfortable-living.side-table-per-bed':
    'ベッドごとのサイドテーブル',
  'camp67-tent-amenity.comfortable-living.centre-table': 'センターテーブル',
  'camp67-tent-amenity.comfortable-living.sofa-chairs': '2x ソファ椅子',
  'camp67-tent-amenity.comfortable-living.side-table-kettle':
    '湯沸しケトル付きサイドテーブル、使い捨てコップ',
  'camp67-tent-amenity.comfortable-living.table-lamp': 'テーブルランプ',
  'camp67-tent-amenity.toiletries': 'トイレタリー',
  'camp67-tent-amenity.toiletries.shared-toilets-twin':
    '7部屋と共有するトイレ&バスルーム',
  'camp67-tent-amenity.toiletries.shared-toilets-dorm':
    '寮全体で共有するトイレ&バスルーム',
  'camp67-tent-amenity.toiletries.shared-toilets-family':
    '3家族と共有するトイレ&バスルーム',
  'camp67-tent-amenity.toiletries.bath-towel': 'ガムチャ（薄い綿のタオル）',
  'camp67-tent-amenity.toiletries.sukrit-soaps-lotion':
    '無料のSukrit Ayurvedaソープとローション',
  'camp67-tent-amenity.toiletries.small-dustbin': '小さなゴミ箱',
  'camp67-tent-amenity.power-storage': '電力と収納',
  'camp67-tent-amenity.power-storage.electric-power-point': '電源コンセント',
  'camp67-tent-amenity.power-storage.electric-power-point-2x':
    '2つの複数スロット付き電源コンセント',
  'camp67-tent-amenity.power-storage.electric-power-point-4-sets':
    '4セットの複数スロット付き電源コンセント（セクションごとに2セット）',
  'camp67-tent-amenity.power-storage.luggage-storage-racks': '荷物収納ラック',
  'camp67-tent-amenity.food-beverage': '飲食',
  'camp67-tent-amenity.food-beverage.drinking-water':
    '飲料水ボトル（1人あたり500ml x 1本）',
  'camp67-tent-amenity.food-beverage.tea-biscuits': '購入可能なティーサシェとビスケット',
  'camp67-tent-amenity.food-beverage.lemongrass-tea-biscuits':
    'Sukrit Lemongrass Tea & Biscuits',
  'camp67-tent-amenity.food-beverage.complimentary-meals':
    '<strong>無料の</strong> 朝食、昼食、夕食（食堂でのビュッフェ）',
  'camp67-tent-amenity.complimentary': '無料',
  'camp67-tent-amenity.complimentary.souvenir':
    '土産 - camp67ブランドのベースボールキャップ（1人あたり1個）',
  'camp67-faq.private-suites': 'プライベートスイートはありますか？',
  'camp67-faq.private-suites.answer':
    '<p>はい！</p><paragraph>キャンプ67では、<twin-room-link>ツインベッドコテージ</twin-room-link>、<family-room-link>ファミリーコテージ</family-room-link>、または<family-room-plus-link>ファミリーコテージプラス</family-room-plus-link>の3つのプライベートコテージオプション（2名、4名、6名収容）を提供しています。他の2つのオプションは、シングルまたは二段ベッドとしての大きなテントドミトリーの一部です。</paragraph><paragraph>右側のお問い合わせフォームを通じてご質問があればお知らせください。また、さらに人目から離れたプライベートスペースをご希望の場合はご相談ください。<kumbh-sukrit-link>Kumbh Sukrit Camp</kumbh-sukrit-link>の提供品をご紹介できます。</paragraph>',
  'camp67-faq.camp-start': 'あなたのキャンプはいつ始まりますか？',
  'camp67-faq.camp-start.answer':
    '<p>1月11日から予約を受け付けます。この日付より早く開始する予定の場合はお知らせします。<camp-start-link>以下を購読してください</camp-start-link> そのような更新情報を受け取るために。</p>',
  'camp67-faq.international-travel': '国際旅行者に適していますか？',
  'camp67-faq.tours-packages': 'ツアーやパッケージを提供していますか？',
  'camp67-faq.kumbh-sukrit': 'Kumbh Sukrit Campとの関係は何ですか？',
  'camp67-faq.all-day-facilities': '終日施設を提供していますか？',
  'camp67-faq.international-travel.answer':
    '<p> はい！<international-travel-link>上記</international-travel-link>に記載したように、2019年のKumbhのエディションでは26か国からの旅行者を受け入れました。フライト予約、インド到着時の交通機関、ここにいる間に利用できるローカルツアーなど、すべて対応しています。</p> <paragraph>もし私たちと話したい場合は、メール、WhatsApp、または以下のライブチャットでお気軽にご連絡ください。また、右側の問い合わせフォームも良い出発点です！</paragraph>',
  'camp67-faq.tours-packages.answer':
    'はい！右側の問い合わせフォームや提供されたメール、電話番号、WhatsApp、またはライブチャットでお気軽にご連絡ください。お客様のニーズを理解し、最も効果的に対応できるようにしたいと思います。',
  'camp67-faq.kumbh-sukrit.answer':
    '<p><kumbh-sukrit-link>Kumbh Sukrit Camp</kumbh-sukrit-link> と camp67 は <swt-link>Sukrit Wellness Tours</swt-link> のバナーの下にあります。簡単に言うと、私たちはすべての三つのベンチャーにわたる合同チームであり、変革的なウェルネス体験を提供することを目的としています。私たちはインドで10年以上にわたり運営しており、全国でさまざまな滞在場所やツアーを提供しています。</p> <paragraph>camp67 は私たちの新しい提供ですが、<kumbh-sukrit-link>Kumbh Sukrit Camp</kumbh-sukrit-link> の以前のエディションの多くの特性を引き継いでいます。以前に滞在したことがあるなら、新しくて馴染み深い組み合わせを気に入っていただけると自信を持っています。</paragraph>',
  'camp67-faq.all-day-facilities.answer':
    'はい！Kumbhキャンプサイトの場所はKumbh以外でも私たちが所有および管理しているため、終日施設を備えています。もし特定の施設に興味がある場合はお知らせください。',
  'camp67-get-in-touch.success-thankyou': 'ありがとうございます。',
  'camp67-get-in-touch.success-message':
    'リクエストを受け取りました。すぐにご連絡いたします！',
  'camp67-get-in-touch': 'お問い合わせ',
  'camp67-get-in-touch.12-hours':
    'マグ メラ 2026 に興味がありますか? 私たちはサポートします！ 今すぐお問い合わせいただければ、12 時間以内にご連絡いたします。',
  'camp67-get-in-touch.placeholder-name': '名前を入力して...',
  'camp67-get-in-touch.error-name': '名前を入力してください',
  'camp67-get-in-touch.placeholder-phone': '電話番号を入力して...',
  'camp67-get-in-touch.error-phone': '有効な電話番号を入力してください',
  'camp67-get-in-touch.placeholder-email': 'メールを入力して...',
  'camp67-get-in-touch.error-email': '有効なメールアドレスを入力してください',
  'camp67-get-in-touch.placeholder-inquiry': 'お問い合わせ内容を入力して...',
  'camp67-get-in-touch.error-inquiry': 'お問い合わせ内容を入力してください',
  'camp67-experience-kumbh.the-kumbh': 'マグ メラ',
  'camp67-experience-kumbh.engage-unique-experience':
    'マグ・メーラの最も<unique-highlight>ユニーク</unique-highlight><br />な体験に参加しませんか。',
  'camp67-experience-kumbh.sadhus':
    'Nāga Sadhus との交流から、人類と文化の最大の集まりへの参加まで、マグ メラを体験してください。',
  'camp67-experience-kumbh.sound.mobile': 'マグ メラの音',
  'camp67-experience-kumbh.play-sound': 'マグ メラの音を聞く',
  'camp67-experience-kumbh.pause-sound': 'マグ メラの音を一時停止',
  'camp67-experience-kumbh.naga-sadhu.image-alt': 'クンブ・メーラーのナガ サドゥ。',
  'camp67-experience-kumbh.naga-sadhu-orange.image-alt':
    'クンブ・メーラーでオレンジ色のガーブを着たナガ サドゥ。',
  'camp67-experience-kumbh.naga-sadhu-beard.image-alt':
    'クンブ・メーラーで独特の長いひげを持つナガ サドゥ。',
  'camp67-experience-kumbh.canoe.image-alt': 'ガンジス川の真ん中でカヌーを漕ぐ男性。',
  'camp67-join-now.book-now': '~ 今すぐ予約 ~',
  'camp67-join-now.interested-in-kumbh':
    '2026年のマグ メラに興味がありますか？ <join-us-text>参加する</join-us-text>',
  'camp67-join-now.book-now-lowest-price':
    '<strong>私たちと一緒に部屋を予約する →</strong><br />開始価格',
  'camp67-join-now.chat-with-us':
    '<strong>私たちとチャット →</strong><br />どんな質問でもお問い合わせください',
  'camp67-footer.stay-informed':
    '<strong>情報を提供します。</strong> 割引やセール情報をお知らせします。スパムは送りません！',
  'camp67-footer.email.placeholder-subtle': 'あなたのメールアドレス...',
  'camp67-footer.email.placeholder':
    'ここにメールアドレスを入力してください。例：ilovecamp67@gmail.com...',
  'camp67-footer.subscribe-for-updates': '更新情報を購読する',
  'camp67-footer.camp67-summary':
    '<swt-link>Sukrit Wellness Tours</swt-link> の一部である camp67 は、<ksc-link>Kumbh Sukrit Camp</ksc-link> のチームによって運営されています。観光省およびインクレディブル インディアと提携して、10年以上にわたってクンブを開催してきました。2026年に<join-us-link>参加する</join-us-link>',
  'camp67-footer.a-product-of': 'の製品',
  'camp67-footer.subscribe-success': '登録が完了しました！',
  'camp67-footer.subscribe-success-message':
    '最新のアップデートやニュースにご登録いただきありがとうございます。これからの展開を私たちと同じように楽しみにしています！',
  'camp67-footer.subscribe-opt-out': 'この購読をいつでもオプトアウトできます。',
  'camp67-content-page.read-more': '続きを読む',
  'camp67-content-page.child.reading-time': '分の読書時間',
  'camp67-packages-page.subtitle': '幅広い宿泊オプションから選ぶことができます。',
  'camp67-packages-page.hero-image-alt': 'ボートが川に浮かぶバラナシの港の夕焼けの景色。',
  'camp67-packages-page.summary': '提供する宿泊施設の詳細を学び、今すぐ予約しよう！',
  'camp67-packages-page-children.summary':
    'camp67が提供する宿泊オプションを閲覧し、今すぐ予約しよう！',
  'camp67-tent-page.twin-room-summary':
    '<p>\n  ツインルームはカップル、友人、兄弟姉妹に最適です。快適でプライベートなテントルームで、マグ メラ会場へ向かい、そして毎日帰ってくるあなただけの完璧な宿泊施設を提供します。\n</p>\n<paragraph>camp67 カフェのコーヒーを手に持って席を取ることをお勧めします。その日の観察結果をお互いに話し合い、次の計画を立てましょう！</paragraph>',
  'camp67-tent-page.family-room-summary':
    '<p>\n家族で旅行する際の最も楽しい部分は、一緒に体験することです。私たちはこのキャンプ67のファミリーコテージでそれを重視しています。\nシングルベッドとクイーンベッドが備わった広々とした空間が待っています。\n</p>\n<paragraph>特にそれぞれがどこで寝るかを選ぶのが一苦労かもしれませんが、それを乗り越えた後は、きっと自宅のように感じることでしょう。</paragraph>',
  'camp67-tent-page.family-room-plus-summary':
    '<p>\nファミリーコテージで寝床を選ぶのが難しいと思ったら、ファミリーコテージプラスに入るときが来ます… 2つのクイーンベッドと付属の二段ベッドを備えたこの客室は、6人用の家族やグループに最適です。\n</p>\n<paragraph>家族での素晴らしい時間を共有しましょう。他のことは心配しないでください - 荷物は安全で、コーヒーは常に温かく、そしてあなたを待っています…</paragraph>',
  'camp67-tent-page.dorm-single-summary':
    '<p>\nソロトラベラー、ブロガー、またはデジタルノマドとして人々と出会いたいですか？ドミトリールームはそのために作られました。典型的な旅行ホステル環境で他の人と一緒に過ごしましょう。8つのベッドが一部屋になっており、「少し空間が欲しい」と「おしゃべりしたい」のデリケートなバランスが取れています。\n</p>',
  'camp67-tent-page.dorm-bunk-summary':
    '<p>\nさらに伝統的なソロトラベラー体験を求めているなら、大型のドミトリールームでバンクをつかんでください！これらの部屋は16人収容でき、一晩中ゴーストストーリーを語ってくれる一人に出会うことができる絶好の場所です。\n</p>\n<paragraph>グループで旅行している場合は、特に興味深いオプションかもしれません。その場合はご連絡ください、対応いたします。</paragraph>',
  'camp67-tent-page.back-to-packages': 'すべてのパッケージに戻る',
  'camp67-tent-page.book-tent-now': '今すぐこの部屋を予約する！',
  'camp67-who-we-are.subtitle': 'camp67の背後にある精神。',
  'camp67-who-we-are.hero-image-alt': 'ボートが川に浮かぶバラナシの港の夕焼けの景色。',
  'camp67-who-we-are.summary':
    'Kumbh Sukritのチームからcamp67が登場: 2026年のマグメラで最も手頃で、静かで平和なオファリング。',
  'camp67-who-we-are.content':
    '\n  <p>\n        一言で言えば: <strong>camp67</strong> は、クラフト、文化的伝統、そしてマグメラの伝統に対する敬意の労働です。\n      </p>\n      <paragraph>\n        私たちは、さまざまな職業および個人的な背景を持つ多様なグループであり、私たちの成果と役割を脇に置いて、この素晴らしい冒険を祝います。これは、世界中から何百万もの巡礼者が6年ごとに行うものです。私たちにとって、マグメラは変化の入り口です。\n      </paragraph>\n      <paragraph>\n        camp67は、すべての人々を歓迎するマグメラのキャンプ場を目指しています。 「すべて」の部分は私たちにとって最も重要です。なぜなら、クンブの精神と基底原則は「人間」です。\n      </paragraph>\n      <paragraph>\n        camp67では、人生という冒険を求めて世界中から訪れる人々に出会えるだけでなく、24時間営業のカフェで彼らと座り、人生の物語を話し合えます。ブロガーや旅行者に出会い、プラヤガラージの最高の屋台料理がどこにあるか教えてもらえます。ユニフォームを着ているにもかかわらず、私たちのチームもあなたと一緒に座り、<the-land-link>camp67の土地</the-land-link> の物語を語り、そのユニークさにあなたを驚かせるでしょう。\n      </paragraph>\n      <paragraph>\n        私たちがあなたを迎えることに興奮しているのはなぜでしょうか? それは、あなたがここを気に入って、また戻ってきたいと思うと確信しているからです。\n      </paragraph>\n      <paragraph>\n        信じてください。\n        <camp67-kumbh-link>以前にもやったことがあります</camp67-kumbh-link>: 2019年のクンブメラでは、Kumbh Sukritとして。\n      </paragraph>\n      <paragraph>\n        Kumbh Sukritは、10年以上にわたってクンブに関わっています。世界中の25カ国以上から10,000人以上のゲストを招待してきた我々は、様々な業界の専門家であり、古代インドの伝統と高品質のサービスへの情熱を持っています。\n      </paragraph>\n      <paragraph>\n        過去10年間で、これは私たちをクンブメラの素晴らしい遺産とユニークさを通じて独自の旅へと導いてきました。\n        2019年には、有名な「Sanskriti Vann」でテント村を舞台に、世界中から何千人もの客を迎えました。ここでは、古代のリシやヨギが数年、数十年にわたって瞑想をしました。\n      </paragraph>\n      <paragraph>\n        これらすべての経験を通じて、camp67を立ち上げ、マグメラの生涯の経験を提供できることにとても興奮しています。\n      </paragraph>\n      <p>\n        当社の場所を確認するには、<maps-link>Google マップ</maps-link>をご覧ください。Daraganj、PrayagrajのSangam Ghatの近くにあります。\n      </p>\n      ',
  'camp67-who-we-are-summary':
    'Kumbh Sukritのチームからcamp67が登場: 2026年のマグメラで最も手頃で、静かで平和なオファリング。',
  'camp67-and-kumbh.subtitle': 'なぜマグメラを評価するのか？',
  'camp67-and-kumbh.hero-image-alt': 'ボートが川に浮かぶバラナシの港の夕焼けの景色。',
  'camp67-and-kumbh.summary':
    'なぜマグメラ？ さまざまな祭りやイベントの中で、なぜマグメラを選ぶのでしょうか？ そうですね、それは隠された詳細にあるのです…',
  'camp67-and-kumbh.content':
    '\n    <paragraph>\n      私たちは何年も前にマグメラに恋しました。この世には、これほどまでに広大でユニークなイベントは非常に少なく、人類の歴史においても、このようなイベントはほとんどありません。\n    </paragraph>\n    <paragraph>\n      なぜでしょう？ 140億人以上の人々が、各自の希望と夢を胸に同じ場所に集まる様子を見ることができるのはどこでしょうか？ それはまさに巨大なイベントですが、その美しさは数字にではなく、地上で見られるものにあります。\n    </paragraph>\n    <paragraph>\n      まず始めに: マグメラに行くと、ガンジス川のほとりにある無数の小規模から中規模の会場が迎えてくれます（camp67の所在地から徒歩圏内です）。プラヤーグ・ラージ市がイベント前に建設するテント都市の間にあって、どこにでも配置されています。これによって朝の散歩は完全に一変します。マグメラ会場をぶらぶら歩き始めるときはひとつの印象を持っていますが、それが完全に刷新されて、新たな視点が広がります。\n    </paragraph>\n    <paragraph>\n      これが具体的にどのように見えるのでしょうか？ インド中から精神的指導者たちが大量に集結します。様々な背景を持つナガ・サドゥたちが物語の助けを借りて一般の人々に自らを紹介します。農村の家族は新たな人生の始まりの祝福を求めてここに集います。無限の物語と体験があります。\n    </paragraph>\n    <paragraph>\n      確かなことはひとつあります: あなたは確実にマグメラを自分自身の物語と共に去ることになるでしょう。\n    </paragraph>\n  ',
  'camp67-and-the-land.subtitle': 'インドの古代の物語。',
  'camp67-and-the-land.hero-image-alt': 'ボートが川に浮かぶバラナシの港の夕焼けの景色。',
  'camp67-and-the-land.summary':
    'camp67が位置する土地は、かつての歴史に包まれています。それは世界で最もユニークな場所の一つです。',
  'camp67-and-the-land.content':
    '\n    <paragraph>\n      camp67はサンスクリティ・ヴァンのすぐ近くに位置しています。文字通りに訳すと、サンスクリティ・ヴァンは‘神聖な森’です。何千年も前、この場所はリシやマハリシたちが妨げられることなく瞑想するための神聖な場所でした。ご存じないかもしれませんが、彼らの瞑想は数ヶ月から数年、何十年にも及ぶことがあります。これこそがインドのリシのユニークさです。camp67が直接座している土地と、インドラ（戦争、雨、雷のヒンドゥー教の神、デヴァ達の王）の伝説とのつながりもあります。\n    </paragraph>\n    <paragraph>\n      ここで瞑想するリシたちは、サンスクリティ・ヴァンに今も立っている木々の下に座ります。この空間に入ると、木々はあなたの上にそびえ立ち、外の喧騒からの古代の守護を提供します。\n    </paragraph>\n    <paragraph>\n      ぜひ自分自身で想像してみてください: インドの賑やかで騒がしい通りを離れ、左に曲がってキャンプ場に入ります。そこに入ると、外の世界の音が聞こえにくくなり、歴史に富んだ囲いに守られながらいることになります。それはこれまで味わったことのない静けさを提供してくれます。マグメラ2026では、camp67のメンバーがこのユニークな森への排他的なアクセスを得ることができます。\n    </paragraph>\n    <paragraph>\n      最後に: camp67からわずか10分のところに、マグメラの旅に出ようとしている一億人がいます。突然、その土地の魅力があなたに浸透してきます。…そして、ついにあなたはマグメラキャンプを構築し、誰もが参加できるよう招待することになります！\n    </paragraph>\n    <paragraph>\n      これがcamp67の始まりでした。確かに土地が最初に来たのです。\n    </paragraph>\n  ',
  'camp67-the-camp.subtitle': '私たちについてもっと学ぼう！',
  'camp67-the-camp.hero-image-alt': 'ボートが川に浮かぶバラナシの港の夕焼けの景色。',
  'camp67-the-camp.summary':
    'camp67が存在する理由と、私たちがやっていることを駆り立てるものについてもっと学びましょう。',
  'significance-of-kumbh.subtitle': 'Kumbhの物語。',
  'significance-of-kumbh.hero-image-alt':
    'アスラ（左）とデヴァ（右）がミルクの海をかき混ぜる。',
  'significance-of-kumbh.summary':
    'クンブの物語は象徴的かつ文字通りです。文字通りの意味では：クンブは「ポット」を意味します。それは不死の神聖なネクターを含むポットを表します。',
  'significance-of-kumbh.content':
    '\n    <p>\n      我々は、ヒンドゥー教の神々 (Devās) と悪魔 (Rākshasas) の間の永遠の戦いを認識するためにクンブを祝います。\n    </p>\n    <paragraph>\n      その話によると、何百年前、ヒンドゥー教の神々と悪魔が力を合わせ、乳の海 (Kshirasagara) をかき混ぜ、最も貴重な存在である不死のネクター (Amritā) を手に入れるために山マンダールをかき混ぜる地点にし、蛇のヴァースキを縄にしました。ヴィシュヌ神はカメの形をしてその山を支えました。\n    </paragraph>\n    <paragraph>\n      海をかき混ぜると、神聖なものが生じました。そこから現れたのは、女神ラクシュミ (ヒンドゥー教の富、運命、繁殖力、力、美と繁栄の女神)、月、そして期待通りに壺 (Kumbh) に満たされた神聖なアムリタでした。しかし、ネクターが現れるとすぐに、悪魔たちはそれを手に入れようとしました。 ヴィシュヌ神はヒンドゥー教の魅惑の女神モヒニの姿をして悪魔たちを欺き、アムリタを全てのヒンドゥー教の神々に分け与えました。\n    </paragraph>\n    <paragraph>\n      悪魔たちから逃げながら、ヒンドゥー教の神々がインド中で追いかけられ、そのネクターを飲む時に不死のネクターの滴がインドの異なる地域に落ちました。これがクンブが祝われる4つの場所、すなわちハリドワール、プラヤグ、ナシック、そしてウジャインです。したがって、これがサムドラ・マンタンの物語であり、「クンブ」の基礎となっています。\n    </paragraph>\n    <paragraph>\n      より象徴的な意味では、クンブは体内に不死のネクターが座っている人間の体を表しています。これについては、古代のリシと賢者だけが話しています。\n    </paragraph>\n  ',
  'paush-purnima.subtitle': '月の神、チャンドラ神の日。',
  'paush-purnima.hero-image-alt': '雲に覆われた満月の夜景。',
  'paush-purnima.summary': '月の神、チャンドラ神を記念する日。',
  'paush-purnima.content':
    '\n    <p>\n      ポーシュ月の満月の日は、ヒンドゥー教の暦に従って、ポーシュプールニマとして知られています。これは月と重要な関連性を持ち、ガンジス川で浄化、再生、自身の内面と身体の清めのための神聖な沐浴に非常に良いとされています。\n    </p>\n    <paragraph>\n      この日は、ヒンドゥー教の月の神、チャンドラ神から祝福を受けるための最適な日でもあります。信者たちは、この日に特定の断食を行います。\n    </paragraph>\n  ',
  'mauni-amavasya.subtitle': 'マグの栄光。',
  'mauni-amavasya.hero-image-alt':
    '広大なガンジス川でボートに乗る人々のわずかに陽が差す景色。',
  'mauni-amavasya.summary': 'マグ・メーラの主要な沐浴日。沈黙と内省の日、数百万の中で。',
  'mauni-amavasya.content':
    '\n    <p>\n      新月の日にあたるこの日は、マグ・メーラ期間中の最も吉祥な沐浴日とされています。信者はこの日にマウン・ヴラタ（沈黙の誓い、すなわち全く話さないこと [インドのリシたちはさらにそれを自己の内面での完全な沈黙と説明しています]）を守り、沈黙の中で自己の精神性を省み、彼らに深い内面的な利益をもたらすと信じられている儀式を行います。\n    </p>\n    <paragraph>\n      『マウニ』という語は文字通り『沈黙』と訳されます。それは内なる平穏を必要とする精神的な向上への旅の重要な要素と考えられています。\n    </paragraph>\n  ',
  'makar-sankranti.subtitle': '季節の変わり目。',
  'makar-sankranti.hero-image-alt': '明るい陽の光を浴びた白い花畑。',
  'makar-sankranti.summary':
    'ヒンドゥー教の暦で最も縁起の良い日のひとつ。季節の変わり目と新たな始まり。',
  'makar-sankranti.content':
    '\n    <p>\n      これは、太陽が星座の山羊座（マカラ）に移行する時、ヒンドゥー教の暦の中で最も神聖な日とされています。この日は冬の終わりと日が長くなる始まりを象徴しています。この日は神聖なガンジス川で沐浴し、貧しい人々に施しをするのが特に良いとされ、神の祝福を捕えるための特別な日です。\n    </p>\n    <paragraph>\n      マカラ・サンクランティは新しいことを始める理想的な時期とも見なされ、人生と自分自身の再発明を季節の変化同様に行います。\n    </paragraph>\n  ',
  'maha-shivratri.subtitle': 'シバの大夜。',
  'maha-shivratri.hero-image-alt': '青空を背景にしたシバの像。',
  'maha-shivratri.summary':
    'マハー・シヴラートリーは、マグ・メーラの終了直前に観測される、シヴァ神に捧げられた日です。',
  'maha-shivratri.content':
    '\n    <p>\n      これはシヴァ神に捧げられた日であり、マグ・メーラの終了直前に観測されます。\n      信者は断食し、シヴァ神を讃えるための聖なる儀式を行います。\n      この日に沐浴することは、シヴァ神を讃えていると信じられており、信者が\n      解放と主からの祝福を受け、人生からすべての闇を払いのけるのを助けます。\n    </p>\n    <paragraph>\n      この日には、特定のマントラや賛歌が唱えられ、歌われます。\n    </paragraph>\n  ',
  'maghi-purnima.subtitle': '満月の日。',
  'maghi-purnima.hero-image-alt':
    '青空を背景にしたシルエットで、オレンジ色の衣をまとった高齢のサドゥー。',
  'maghi-purnima.summary':
    '創造の神、ブラフマと、クンブ期間中に川のほとりで生活する聖人のコミュニティに関連付けられています。',
  'maghi-purnima.content':
    '\n    <p>\n      この満月の日は創造の神であるブラフマ神に関連しています。\n    </p>\n    <paragraph>\n      この日に沐浴することは、すべての神々からの祝福と支援を得ると信じられており、喜捨をするとカルパヴァシス（クンブの期間中に川のほとりに住んでいる、すべての快適さを放棄した聖者の共同体）に関連しています。\n    </paragraph>\n  ',
  'basant-panchami.subtitle': '春の始まり。',
  'basant-panchami.hero-image-alt':
    'ヒンドゥー教の知識と芸術の女神サラスワティ。ラヴィ・ヴァルマによる絵から取られています。',
  'basant-panchami.summary':
    '春の到来として祝われるBasant Panchamiは、ヒンドゥー教の知識と芸術の女神、サラスワティに捧げられています。',
  'basant-panchami.content':
    '\n    <p>\n      春の到来を祝う祭りとして、バサント・パンチャミは知識と芸術のヒンドゥー教の女神であるサラスヴァティに捧げられます。信者たちは黄色い服を着て、黄色い花をサラスヴァティ女神に捧げます。インド中の教育機関は女神への深い敬意を表し、特別な祈りを行います。\n    </p>\n    <paragraph>\n      この神聖な日に沐浴することは知識と知恵を授けるとされています。\n    </paragraph>\n  ',
  'kumbh-2025.subtitle': 'マグ・メーラ 2026 の旅に出発しましょう。',
  'kumbh-2025.hero-image-alt': 'ガンジス川のボートにあるバラナシの港の日没の景色。',
  'kumbh-2025.summary':
    'マグ・メーラの重要性と、この壮大な祭りの間に行われるイベントについてもっと学びましょう。',
  'camp67-reservation.book-with-us': '私たちと一緒に旅行を予約する',
  'camp67-reservation.timeout.title': 'ご予約を確保するために、残り10分です。',
  'camp67-reservation.timeout.description':
    'ご注意ください、高い予約需要により、お客様の予約を長期間保持できません。',
  'camp67-reservation.timeout.ok': '了解しました',
  'camp67-reservation.form.step-1': '<strong>ステップ 1/3:</strong> テント体験を選択',
  'camp67-reservation.form.step-1.adult': '大人',
  'camp67-reservation.form.step-1.children': '子供',
  'camp67-reservation.form.step-1.children-detail': '18歳未満',
  'camp67-reservation.form.step-2': '<strong>ステップ 2/3:</strong> 日付を選択',
  'camp67-reservation.form.step-2.tent-option.unavailable':
    '選択した日付の間、この部屋は利用できません。',
  'camp67-reservation.form.step-2.tent-option.image-alt':
    'camp67の{{type}}オファーの下で提供されるテント体験を表示しています。',
  'camp67-reservation.form.step-3':
    '<strong>ステップ 3/3:</strong> 詳細を入力してください',
  'camp67-reservation.form.step-3.guests': 'ゲストのリスト*',
  'camp67-reservation.form.step-3.disclaimer':
    'すべてのゲストの最小限の詳細が必要です。詳細については<payment-policy-link>我々のポリシー</payment-policy-link>を参照してください。',
  'camp67-reservation.form.step-3.additional-bed': '追加ベッド',
  'camp67-reservation.form.step-3.guests.enter-name': '名前を入力...',
  'camp67-reservation.form.step-3.guests.enter-age': '年齢を入力...',
  'camp67-reservation.form.step-3.gender-male': '男性',
  'camp67-reservation.form.step-3.gender-female': '女性',
  'camp67-reservation.form.step-3.gender-non-binary': 'ノンバイナリー',
  'camp67-reservation.form.step-3.gender-none': '該当なし',
  'camp67-reservation.form.step-3.gender-prefer-not-to-say': '回答しない',
  'camp67-reservation.form.step-3.primary-contact': '主要な連絡先*',
  'camp67-reservation.form.step-3.primary-contact.inform':
    '予約の更新について通知する相手を選択してください。すべてのデータは<privacy-policy-link>安全に扱われます。</privacy-policy-link>',
  'camp67-reservation.form.step-3.primary-contact.select':
    '主要な連絡先を選択してください',
  'camp67-reservation.form.step-3.primary-contact.email': 'メールアドレスを入力...',
  'camp67-reservation.form.step-3.primary-contact.phone': '電話番号を入力...',
  'camp67-reservation.form.submit.bathing-added': '入浴日付に追加されました。',
  'camp67-reservation.form.submit.bathing-charged': '入浴日付で請求されました。',
  'camp67-reservation.form.submit.night': '夜',
  'camp67-reservation.form.submit.nights': '夜',
  'camp67-reservation.form.submit.room': '部屋',
  'camp67-reservation.form.submit.rooms': '部屋数',
  'camp67-reservation.form.submit.empty': '詳細と日付を先に入力してください。',
  'camp67-reservation.form.submit.total': '合計',
  'camp67-reservation.form.submit.price-shown-in': '表示価格',
  'camp67-reservation.form.submit.exchange-calculated':
    '為替レートは<br />毎日計算されます',
  'camp67-reservation.payment': '支払い',
  'camp67-reservation.payment.tandc':
    '<terms-of-service-radio>サービス条件</terms-of-service-radio>に同意します',
  'camp67-reservation.payment.domestic-and-international':
    'インドおよび国際のお客様向け。',
  'camp67-reservation.payment.international': '国際のお客様向け。',
  'camp67-reservation.payment.provider-alt': '支払いプロバイダのロゴ',
  'camp67-reservation.payment.continue': '支払いへ進んで確定',
  'camp67-contact.contact-us': 'お問い合わせ',
  'camp67-contact.offered-by': 'camp67 は提供されています',
  'camp67-contact.address': '本社住所',
  'camp67-contact.questions': 'ご質問や懸念については、以下にご連絡ください:',
  'camp67-contact.email': 'メール',
  'camp67-contact.phone': '電話',
  'camp67-contact.see-tos': '利用規約を参照してください',
  'camp67-reservation.form.step-1.summary.dates': 'ご宿泊の日程',
  'camp67-reservation.form.step-1.summary.guests': 'ゲスト',
  'camp67-reservation.form.step-2.summary.rooms': '選択した部屋',
  'camp67-reservation.form.step-2.summary.rooms.empty': '部屋を選択してください',
  'camp67-reservation.form.step-3.summary.guests': 'ゲストの詳細',
  'camp67-reservation.form.step-3.summary.guests.empty': 'ゲストの詳細を入力してください',
  'camp67-reservation.form.step-3.summary.primary': '主要連絡先',
  'camp67-reservation.form.step-3.summary.primary.empty': '主要連絡先を提供してください',
  'camp67-reservation.form.step-1.summary.dates.value': 'から',
  'camp67-reservation.form.step.disabled.tooltip': 'まず前のステップを完了してください。',
  'camp67-reservation.form.step-1.summary.dates.empty-start': '開始日を選択してください',
  'camp67-reservation.form.step-1.summary.dates.empty-end': '終了日を選択してください',
  'camp67-reservation.form.step-1.summary.guests.empty': 'ゲストの人数を選択してください',
  'camp67-snackbar.invalid-date-range': '選択した日付範囲は無効です。',
  'camp67-snackbar.invalid-bathing-dates-range':
    '入浴日の予約は最低3日間、2泊の期間が必要です。',
  'camp67-reservation.form.step-1.next': 'ステップ2へ進む',
  'camp67-reservation.form.step-2.next': 'ステップ3へ進む',
  'camp67-reservation.form.step.next': '次のステップ',
  'camp67-reservation.form.step-1.next.tooltip.disabled':
    '最初に部屋を選択してください。',
  'camp67-reservation.form.step-2.summary.rooms.add.tooltip': '1つ追加',
  'camp67-reservation.form.step-2.summary.rooms.subtract.tooltip': '1つ減らす',
  'camp67-reservation.form.step-2.next.tooltip.disabled':
    '最初に日付を入力してください。',
  'camp67-reservation.form.step-3.next.tooltip.disabled':
    'まずゲストと連絡先の詳細を提供してください。',
  'camp67-reservation.form.step.expand': 'ステップを展開する',
  'camp67-reservation.form.step.collapse': 'ステップを折りたたむ',
  'camp67-reservation.form.step-1.tent-option.unavailable':
    'この部屋は選択した日付、総ゲスト数で利用できません。',
  'camp67-reservation.form.step-1.tent-option.image-alt':
    'camp67 で提供されている {{type}} 提供のテント体験を表示しています。',
  'camp67-reservation.form.step-1.room-viewer': '部屋を見る：',
  'camp67-reservation.form.step-1.room-gallery': '画像 {{current}} / {{total}}',
  'camp67-reservation.form.step-1.summary.rooms': '選択した部屋',
  'camp67-reservation.form.step-1.summary.rooms.add.tooltip': '1 追加',
  'camp67-reservation.form.step-1.summary.rooms.subtract.tooltip': '1 減らす',
  'camp67-reservation.form.step-1.summary.rooms.empty': '部屋を選択してください',
  'camp67-reservation.form.step-2.adult': '大人',
  'camp67-reservation.form.step-2.children': '子供',
  'camp67-reservation.form.step-2.children-detail': '18歳未満',
  'camp67-reservation.form.step-2.summary.dates': '滞在の日付',
  'camp67-reservation.form.step-2.summary.dates.empty-start': '開始日を選択してください',
  'camp67-reservation.form.step-2.summary.dates.empty-end': '終了日を選択してください',
  'camp67-reservation.form.step-2.summary.dates.value': 'から',
  'camp67-reservation.form.step-2.summary.guests.empty': 'ゲストの数を選択してください',
  'camp67-reservation.form.step-2.summary.guests': 'ゲスト',
  'camp67-header.see-prices': 'オファリングを見る',
  'camp67-header.inquiry': '興味を表明',
  'camp67-snackbar.invalid-bathing-date-selected':
    '予約は入浴日に開始または終了できません。',
  'camp67-accommodation.price-bathroom-included': '専用バスルーム＆トイレ',
  'camp67-accommodation-and-amenities.private.title':
    'デラックス＆プライベートコテージテント宿泊',
  'camp67-accommodation-and-amenities.dorm.title': 'ドミトリーテント宿泊',
  'camp67-tent-amenity.toiletries.private-bathroom': '専用のトイレとバスルーム設備',
  'camp67-accommodation.price-shared-bathroom-included': '専用バスルームとトイレ付き',
  'camp67-reservation.form.step-3.too-many-guests':
    '<strong>⚠️ ゲストが多すぎます</strong><br/>部屋を追加するか、人数を <tentCapacityCode>{{totalTentCapacity}}</tentCapacityCode> に減らしてください。合計で <roomsCapacityCode>{{totalTentCapacity}} ベッド</roomsCapacityCode> を利用できますが、<guestsCountCode>{{guestCount}} 名のゲスト</guestsCountCode> を入力しました。ご不明な点がございましたら、<bookingsCode>bookings@camp67.com</bookingsCode> にご連絡ください。',
  'camp67-navigation.packages.premium-twin-room': 'プレミアムコテージ',
  'camp67-navigation.packages.private-group-cottage': 'プライベートグループコテージ',
  'camp67-accommodation.premium-twin-room.title': 'プレミアムコテージ',
  'camp67-accommodation.premium-twin-room.image-alt':
    '2つのシングルベッド、荷物置き、椅子とテーブル付きの広々とした部屋。',
  'camp67-accommodation.premium-twin-room.subtitle': '2名用。',
  'camp67-accommodation.premium-twin-room.description':
    '2つのシングルベッドを備えたプレミアムスイート。カップル、友達、または兄弟姉妹に最適です。',
  'camp67-accommodation.premium-twin-room.guests': '2名',
  'camp67-accommodation.private-group-cottage.title': 'プライベートグループコテージ',
  'camp67-accommodation.private-group-cottage.image-alt':
    '8名用の予算に優しいリラックスできる1ベッドのドミトリールーム',
  'camp67-accommodation.private-group-cottage.subtitle':
    'グループ用、ドミトリースタイル。',
  'camp67-accommodation.private-group-cottage.description':
    '大きなプライベートコテージ - シングルベッド8台、トイレとバスルーム付き。',
  'camp67-accommodation.private-group-cottage.guests': '8名',
  'camp67-accommodation.price-per-guest-private': '/ 泊',
  'camp67-tent-page.premium-twin-room-summary':
    '<p>\n  プレミアムコテージは、カップル、友人、兄弟に最適です。これは、快適で広々としていて豪華なテントルームで、マグ メラの会場への日々の旅行を開始し、そこから戻ってくる際に、完璧な滞在を提供します。\n</p>\n<paragraph>キャンプ67のカフェでコーヒーを片手に腰を下ろすことをお勧めします。その日観察したことをお互いに話し合い、次の日の計画を立ててください！</paragraph>',
  'camp67-tent-page.private-group-cottage-summary':
    '<p>\nソロトラベラー、ブロガー、デジタルノマドとして人に会いたいですか？\nこのドミトリールームはあなたのために作られました。他の旅行者と典型的なホステル環境で過ごしましょう。部屋\nの中には8つのベッドがあり、『ちょっと距離を開けたい』と『おしゃべりを楽しみたい』\nの微妙なバランスを保っています。\n</p>',
  'camp67-contact.campsite-address': 'キャンプ場の住所',
  'camp67-contact.helpdesk': 'ヘルプデスク番号',
  'camp67-contact.whatsapp-only': 'WhatsAppメッセージのみ',
  'camp67-contact.outside-india': 'インド国外から',
  'camp67-contact.map': '地図で見る',
  'camp67-tent-amenity.comfortable-living.side-table-glasses':
    '使い捨てグラス付きサイドテーブル',
  'camp67-tent-amenity.comfortable-living.side-table': 'サイドテーブル',
  'camp67-tent-amenity.toiletries.bath-towel-single': 'ガムチャ（薄い綿のタオル）',
  'camp67-tent-amenity.power-storage.electric-power-point-2x-s': '2倍電源コンセント',
  'camp67-tent-amenity.food-beverage.lemongrass-tea': 'Sukrit レモングラスティー',
  'camp67-navigation.kumbh-2025.sacred-gathering-of-magh-mela': 'マグ メラ: 神聖な集まり',
  'significance-of-magh.subtitle': 'マグの神聖な集い。',
  'significance-of-magh.hero-image-alt':
    'マグメラ中にトリヴェニ・サンガムで聖なる沐浴をする信者たち。',
  'significance-of-magh.summary':
    'マグ・メーラは、毎年1月から2月にかけての神聖なヒンドゥー教の月であるマグに開催され、神聖な川の岸辺で沐浴し、瞑想し、精神的向上を求める信者たちの伝統的な集まりです。',
  'significance-of-magh.content':
    '\n    <p>\n      マグ・メーラは、より小規模でありながら同様に深いクンブの兄弟としてよく知られており、プラヤーグラージにあるガンガー川、ヤムナー川、そして神秘的なサラスヴァティー川の神聖な合流点で毎年祝われます。\n    </p>\n    <paragraph>\n      古代の伝統に根ざし、マグの月は精神的な実践にとって極めて吉祥であると考えられています。ヒンドゥー教の聖典であるプラーナには、この期間に神聖な川で沐浴すること、特にトリヴェニ・サンガムで沐浴することが、罪を洗い流し、解放（モクシャ）への道を開くと強調されています。\n    </paragraph>\n    <paragraph>\n      マグ・メーラは単なる沐浴の儀式ではなく、聖者、賢者、禁欲者、そして家庭人が一堂に会す神聖な集会です。インド全土およびその外から人々が集まり、苦行を行い、厳格な生活を観察し、聖典を朗読し、献身に没頭します。多くの人々はカルパヴァスを行い、マグの月の間、簡素な生活を誓い、川岸に滞在し、祈り、瞑想、奉仕のみに専念します。\n    </paragraph>\n    <paragraph>\n      メーラは、信仰の時を超えた連続性と宇宙の周期のリズムを象徴しており、有限と無限の結合を人類に思い出させます。川がサンガムで合流するように、マグ・メーラは真理の探求における身体、心、精神の合流を表しています。\n    </paragraph>\n    <paragraph>\n      象徴的な意味では、川は人間の意識の経路を示し、その合流は自己内における知識、献身、そして行動の統一を象徴しています。マグ・メーラは、個々人が内なる存在を浄化し、清新な明晰さをもってダルマの道を歩むことを促します。\n    </paragraph>\n  ',
  'camp67-inquiry.event-badge': 'Magh Mela 2026 • 1月3日 - 2月18日',
  'camp67-inquiry.hero-subtitle':
    '聖なる合流地点の中心で、モダンな設備を備えたプレミアムテント宿泊',
  'camp67-inquiry.express-interest': '関心を表明する',
  'camp67-inquiry.express-your-interest': '関心を表明する',
  'camp67-inquiry.modal-title': '関心を表明する',
  'camp67-inquiry.modal-subtitle': 'Magh Mela 2026 • 1月3日 - 2月18日',
  'camp67-inquiry.accommodation-preference': '宿泊タイプの希望',
  'camp67-inquiry.no-preference': '希望なし',
  'camp67-inquiry.twin-cottage': 'ツインベッド・コテージ',
  'camp67-inquiry.premium-cottage': 'プレミアム・コテージ',
  'camp67-inquiry.family-cottage': 'ファミリー・コテージ',
  'camp67-inquiry.private-group': 'プライベートグループ・コテージ',
  'camp67-inquiry.dorm-single': 'ドミトリー（シングルベッド）',
  'camp67-inquiry.dorm-bunk': 'ドミトリー（二段ベッド）',
  'camp67-inquiry.checkin': 'チェックイン',
  'camp67-inquiry.checkout': 'チェックアウト',
  'camp67-inquiry.checkin-date': 'チェックイン日',
  'camp67-inquiry.checkout-date': 'チェックアウト日',
  'camp67-inquiry.guests': '人数',
  'camp67-inquiry.number-of-guests': '宿泊人数',
  'camp67-inquiry.how-many': '何名ですか？',
  'camp67-inquiry.guest-singular': '名',
  'camp67-inquiry.guest-plural': '名',
  'camp67-inquiry.guests-10-plus': '10名以上',
  'camp67-inquiry.contact-details': '連絡先情報',
  'camp67-inquiry.full-name': '氏名',
  'camp67-inquiry.email': 'メールアドレス',
  'camp67-inquiry.phone': '電話番号',
  'camp67-inquiry.your-name': 'お名前',
  'camp67-inquiry.email-placeholder': 'you@example.com',
  'camp67-inquiry.phone-placeholder': '+91 XXXXX XXXXX',
  'camp67-inquiry.additional-message': '追加メッセージ（任意）',
  'camp67-inquiry.message-placeholder': '特別なご要望やご質問はありますか？',
  'camp67-inquiry.required-fields-error': '* が付いた必須項目をすべて入力してください',
  'camp67-inquiry.submit-interest': '送信する',
  'camp67-inquiry.submitting': '送信中...',
  'camp67-inquiry.thank-you': 'ありがとうございます！',
  'camp67-inquiry.success-message':
    'ご関心を受け付けました。空き状況と次のステップについて、12時間以内にご連絡します。',
  'camp67-inquiry.close': '閉じる',
  'camp67-inquiry.secure-info': '🔒 お客様の情報は安全に保護されています。',
  'camp67-inquiry.ready-to-experience': 'Magh Mela 2026 を体験する準備はできましたか？',
  'camp67-inquiry.interest-in': '関心を表明：',
  'camp67-we-love-kumbh.full-heading':
    '私たちはKumbhを知り、そして<love-highlight>愛しています</love-highlight>',
  'camp67-reservation.form.step': 'ステップ',
  'camp67-reservation.form.step.continue': '続ける',
  'camp67-reservation.form.step.reset': 'リセット',
  'camp67-reservation.form.step-1.price-per-night': '/泊',
  'camp67-reservation.form.step-1.meals-included': '食事付き',
  'camp67-reservation.form.step-1.private-bathroom': '専用バスルーム',
  'camp67-reservation.form.step-1.shared-bathroom': '共用バスルーム',
  'camp67-reservation.form.step-2.check-in': 'チェックイン日',
  'camp67-reservation.form.step-2.check-out': 'チェックアウト日',
  'camp67-reservation.form.step-3.guests.enter-gender': '性別を選択...',
  'camp67-reservation.form.submit.continue': '続行',
  'camp67-reservation.payment.pay-with': '支払い方法',
  'camp67-reservation.payment.disabled': 'まず利用規約に同意してください。',
  'camp67-reservation.payment.paypal.title': 'PayPalで完了',
  'camp67-reservation.payment.paypal.nearly-there': 'あと少しです！',
  'camp67-reservation.payment.paypal.instructions':
    '以下でPayPalに詳細を入力してお支払いを完了してください。完了後、このページに戻ります。',
  'camp67-reservation.payment.error.title': '問題が発生しました',
  'camp67-reservation.payment.error.description':
    'お支払いを処理できませんでした。もう一度お試しください。',
  'camp67-reservation.payment.error.contact-support': 'サポートに連絡',
  'camp67-accommodation.starting-from': '料金は',
  'camp67-accommodation.per-night': '1泊あたり',
  'camp67-accommodation.capacity': '定員',
  'camp67-accommodation.guest': '名',
  'camp67-accommodation.guests': '名',
  'camp67-accommodation.gallery': 'ギャラリー',
  'camp67-accommodation.about': 'この宿泊施設について',
  'camp67-accommodation.whats-included': '含まれるもの',
  'camp67-accommodation.ready-cta-title': 'Mahakumbh を体験する準備はできましたか？',
  'camp67-accommodation.ready-cta-description':
    'Magh Mela 2026 の枠を確保するために、今すぐ予約しましょう。',
};
